'use client';

import { Label, LabelSize } from '@/components/ui/Label';
import "@/styles/sections/sections.scss";
import Image from 'next/image';
import useDevice from '@/hooks/useDevice';
import { useLanguage } from '@/context/LanguageContext';
const FeatureSection = () => {
    const { isPc } = useDevice();
    const { t, locale } = useLanguage();
    const isKorean = locale === "ko";
    return (
        <div className="feature-section">
            <div className="feature-header">
                
                <Label
                    size={isPc ? LabelSize.large : LabelSize.medium}
                    title={t.feature.label}
                    baseColor="#FEEBF5"
                    highlightColor="#FF0280"
                />
                <p className="title">{t.feature.title}</p>
            </div>

            <div className="features-container">
                <div className='headline'>
                    <p className='description'>{t.feature.description}</p>
                </div>
                <div className='body-container'>
                    <div className='campaign-image-container'>
                        <img
                            src={isKorean ? "/images/features/campaign.png" : "/images/features/campaign_en.png"}
                            alt="feature1"

                        />
                    </div>

                    <div className='creator-list-container'>
                        <p className='title'>{t.feature.info}</p>
                        <div className='creator-item'>
                            <img
                                src={isKorean ? "/images/features/creator-list-1.png" : "/images/features/creator-list-1_en.png"}
                                alt="creator1"

                            />
                        </div>
                        <div className='creator-item'>
                            <img
                                src={isKorean ? "/images/features/creator-list-2.png" : "/images/features/creator-list-2_en.png"}
                                alt="creator2"
                            />
                        </div>
                        <div className='creator-item'>
                            <img
                                src={isKorean ? "/images/features/creator-list-3.png" : "/images/features/creator-list-3_en.png"}
                                alt="creator3"
                            />
                        </div>
                        <div className='creator-item'>
                            <img
                                src={isKorean ? "/images/features/creator-list-4.png" : "/images/features/creator-list-4_en.png"}
                                alt="creator3"
                            />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default FeatureSection;